import React, { useContext, useEffect, useState } from 'react';

import AuthContext from '../../../services/firebase/AuthContext';
import FireDataContext from '../../../services/firebase/FireDataContext';
import QuoteListItem from './MemberQuoteCard';

const MemberQuotesList = () => {
    const { currentUser } = useContext(AuthContext);
    const db = useContext(FireDataContext);

    const [quotes, setQuotes] = useState();

    useEffect(() => {
        const unsubscribe = db.subscribe({
            path: `intermediaries/${currentUser.uid}/quotes`,
            hook: data => {
                setQuotes(data.filter(quote => !quote.booking));
            },
            context: 'MemberQuotesList'
        });

        return unsubscribe;

    }, [db, currentUser.uid])

    if (!quotes) return <></>;

    return (
        <div>
            {
                quotes.sort((a, b) => b.ts - a.ts).map(q => {
                    return <QuoteListItem key={q.id} quote={q} />
                })
            }
        </div>
    )
};

export default MemberQuotesList;